import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MaskLines, Reveal } from "@/components/Motion";
import { CHEESECAKES } from "@/data/site";
import { EASE } from "@/lib/api";

export const Cheesecakes = () => {
  const [active, setActive] = useState(0);
  const c = CHEESECAKES[active];

  return (
    <section data-testid="cheesecake-section" className="bg-espresso text-cream overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-28 md:py-44 grid lg:grid-cols-12 gap-16 lg:gap-12 items-center">
        <Reveal className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative h-[440px] sm:h-[560px] lg:h-[640px] overflow-hidden rounded-t-[999px] bg-cocoa">
            <AnimatePresence initial={false}>
              <motion.img key={c.img} src={c.img} alt={`${c.name} cheesecake slice`} data-testid="cheesecake-image"
                initial={{ opacity: 0, scale: 1.06 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.9, ease: EASE }} className="absolute inset-0 w-full h-full object-cover" />
            </AnimatePresence>
          </div>
        </Reveal>
        <div className="lg:col-span-5 lg:col-start-8 order-1 lg:order-2">
          <p className="text-[11px] uppercase tracking-[0.32em] text-gold flex items-center gap-4"><span className="w-10 h-px bg-gold" />Seasonal · Limited Time</p>
          <MaskLines lines={["Cheesecake", <span className="italic">Slices</span>]} className="mt-8 font-display font-light text-6xl sm:text-7xl lg:text-8xl leading-[0.9]" />
          <Reveal delay={0.15}>
            <p className="mt-8 text-[#D9CBBC] leading-relaxed max-w-md">Thick, creamy slices with indulgent toppings. Order one, or mix and match in a 2-slice or 4-slice box.</p>
          </Reveal>
          <ul className="mt-12 border-t border-cream/15">
            {CHEESECAKES.map((x, i) => (
              <li key={x.name} data-testid={`cheesecake-flavor-${i}`} onMouseEnter={() => setActive(i)} onClick={() => setActive(i)}
                className="py-6 border-b border-cream/15 cursor-default">
                <span className="flex items-baseline gap-6">
                  <span className="text-xs tracking-[0.2em] text-gold">0{i + 1}</span>
                  <span className={`font-display text-3xl md:text-4xl transition-colors duration-500 ${active === i ? "text-gold" : "text-cream"}`}>{x.name}</span>
                </span>
                <p className={`mt-3 pl-10 text-sm leading-relaxed transition-colors duration-500 ${active === i ? "text-[#E9DED2]" : "text-[#CDBBA8]"}`}>{x.desc}</p>
              </li>
            ))}
          </ul>
          <Reveal delay={0.1} className="mt-12 flex flex-wrap items-center gap-8">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-[#CDBBA8]">Per slice</p>
              <p data-testid="cheesecake-price" className="font-display text-5xl text-cream">$6</p>
            </div>
            <Link to="/shop/cheesecake-slices" data-testid="cheesecake-order" className="btn btn-light">Order Slices</Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
